import React, { useState } from "react";
import ApiTabsNav from "./components/ApiTabsNav";
import TextToTextTab from "./tabs/TextToTextTab";
import TextToSpeechTab from "./tabs/TextToSpeechTab";
import SpeechToTextTab from "./tabs/SpeechToTextTab";
import SpeechTranslationsTab from "./tabs/SpeechTranslationsTab";

const ApiDetails = () => {
  const [activeTab, setActiveTab] = useState("text-to-text");

  return (
    <div className="w-full flex flex-col gap-6 max-w-[1440px] mx-auto px-4 sm:px-6 py-6 sm:py-8">
      {/* Top API Selector Tabs Matching Provided Design */}
      <div className="w-full border-b border-[#E0E4E2]/80 pb-6 mb-2">
        <ApiTabsNav activeTab={activeTab} onTabChange={setActiveTab} />
      </div>

      {/* Active Tab Documentation Content */}
      <div className="w-full transition-opacity duration-200">
        {activeTab === "text-to-text" && <TextToTextTab key="text-to-text" />}
        {activeTab === "text-to-speech" && <TextToSpeechTab key="text-to-speech" />}
        {activeTab === "speech-to-text" && <SpeechToTextTab key="speech-to-text" />}
        {activeTab === "speech-translations" && <SpeechTranslationsTab key="speech-translations" />}
      </div>
    </div>
  );
};

export default ApiDetails;
